import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const data = [
  { date: "مايو 1", value: 60 },
  { date: "مايو 2", value: 50 },
  { date: "مايو 3", value: 70 },
  { date: "مايو 4", value: 80 },
  { date: "مايو 5", value: 45 },
  { date: "مايو 6", value: 60 },
  { date: "مايو 7", value: 55 },
  { date: "مايو 8", value: 91 },
  { date: "مايو 9", value: 65 },
  { date: "مايو 10", value: 58 },
  { date: "مايو 11", value: 67 },
  { date: "مايو 12", value: 73 },
];

const WeaklyAttendance = ({ t }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return <div>{`${payload[0].value}%`}</div>;
    }

    return null;
  };
  return (
    <div className="p-4 rounded-lg bg-sideBar">
      <h2 className="my-3 font-bold ">{t("weaklyAttendanceRate")}</h2>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data}>
          <defs>
            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FDC168" stopOpacity={0.4} />
              <stop offset="100%" stopColor="#FDC168" stopOpacity={0} />
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#2A3B5F" />
          <XAxis
            dataKey="date"
            reversed
            tick={{ fill: "white", fontSize: 12 }}
            tickLine={false}
          />
          <YAxis
            tickFormatter={(v) => `${v}%`}
            tick={{ fill: "white", fontSize: 12, textAnchor: "end", dx: -20 }}
            domain={[0, 100]}
            tickLine={false}
          />
          <Tooltip content={<CustomTooltip />} />

          <Line
            type="monotone"
            dataKey="value"
            stroke="none"
            fill="url(#colorValue)"
            fillOpacity={1}
          />

          <Line
            type="monotone"
            dataKey="value"
            stroke="#FDC168"
            strokeWidth={2}
            dot={{
              r: 4,
              fill: "white",
              stroke: "#FDC168",
              strokeWidth: 2,
            }}
            activeDot={{
              r: 6,
              fill: "#FDC168",
              stroke: "white",
              strokeWidth: 2,
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeaklyAttendance;
